module.exports = __webpack_public_path__ + "static/astra-logo-e066e10ac59f12e157ff5c1f07725e22.png";